import React, { useState } from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { getf } from './sectionHelpers';

const VARIANT_COLORS: Record<string, { bg: string; color: string }> = {
  info:       { bg: '#2563eb', color: '#fff' },
  warning:    { bg: '#d97706', color: '#fff' },
  success:    { bg: '#16a34a', color: '#fff' },
  promo:      { bg: 'linear-gradient(90deg, var(--brand-primary, #1a365d), var(--brand-secondary, #2563eb))', color: '#fff' },
  'bold-color': { bg: '#f97316', color: '#fff' },
  dark:       { bg: '#0f172a', color: '#fff' },
  light:      { bg: '#f1f5f9', color: '#1e293b' },
};

const AnnouncementBar: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const variant = c.variant || section.variant || 'info';
  const colors = VARIANT_COLORS[variant] || VARIANT_COLORS.info;

  // Custom colors override variant defaults (Python behaviour)
  const customBg = c.background_color;
  const bg = customBg || colors.bg;
  const textColor = c.text_color || colors.color;
  const isGradient = bg.startsWith('linear-gradient') || bg.startsWith('radial-gradient');

  const barStyle: React.CSSProperties = {
    ...(isGradient ? { background: bg } : { backgroundColor: bg }),
    color: textColor,
    padding: '10px 48px 10px 16px',
    textAlign: 'center',
    fontSize: '0.9rem',
    fontWeight: 500,
    position: 'relative',
    lineHeight: 1.4,
  };

  // Python uses `text` primary, `message` as fallback
  const msgText = getf(c, 'text', 'message') || 'Announcement goes here.';
  // Python uses `link_url` primary, `url` as fallback
  const linkHref = getf(c, 'link_url', 'url');
  const linkLabel = getf(c, 'link_text', 'link_label');

  return (
    <div className="sb-render sb-render-announcement-bar" style={barStyle}>
      <InlineEditText tag="span" controlKey="text">
        {msgText}
      </InlineEditText>

      {(linkLabel || linkHref) && (
        <>
          {' '}
          <a
            href={linkHref || '#'}
            style={{
              color: 'inherit',
              fontWeight: 700,
              textDecoration: 'underline',
              marginLeft: 8,
            }}
          >
            <InlineEditText tag="span" controlKey="link_text">
              {linkLabel || 'Learn more →'}
            </InlineEditText>
          </a>
        </>
      )}

      {c.dismissible !== false && (
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss announcement"
          style={{
            position: 'absolute',
            right: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '1.25rem',
            lineHeight: 1,
            opacity: 0.8,
            padding: '4px 6px',
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AnnouncementBar;
